module.exports = __webpack_public_path__ + "img/paul.4f3a68d8.png";